import { createServerOnlyFn } from "@tanstack/react-start";
import type { MatchResult } from "@wags/matchmaker/scoring/match-result.contract.ts";
import { getMatchmaker } from "@/lib/core/matchmaker-core.server";

export type { MatchResult };

export const computeMatchScore = createServerOnlyFn(
    async (input: {
        listingId: string;
        conversationId?: string;
        userId: string;
        comment?: string;
        scoringMode?: "deterministic" | "llm";
    }): Promise<MatchResult> => {
        return await (await getMatchmaker()).scorer.computeCompatibility(input);
    },
);
